import $ from "jquery";
import preloader from "./preloader";
import { allowedLocales } from "scripts/utils/constants";

let LatLng = [];
const ALL_CITIES_ID = "all";
let googleMapClasses = null;
let bounds;
const cache = {};
const mapOptions = {
  mapTypeId: null,
  scaleControl: true,
  mapTypeControl: false,
  disableDefaultUI: true,
  mapId: "725a56243381c957"
};
let mapWidth = 1600;
let mapHeight = 768;
let thisMap = null;
let markers = [];
let markerCluster = null;

if (!Array.isArray(window.locations)) {
  if (window.locations && Object.prototype.hasOwnProperty.call(window.locations, "lat")) {
    LatLng.push(window.locations);
  }
} else {
  LatLng = window.locations;
}

/**
 * Helper function to load an external script.
 */
function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
    document.head.appendChild(script);
  });
}

/**
 * Initializes the Google Map and loads necessary scripts.
 * @param {Function} callback - Optional callback function to execute after the map is initialized.
 * @return {Promise<void>} A promise that resolves when the map is initialized.
 * @throws {Error} If the Google Maps API or MarkerClusterer scripts fail to load.
 */
async function initializeMap(callback) {
  const mapHolder = document.getElementById("map");
  if (!mapHolder) return;

  let locale = document.documentElement.lang;
  if (!(locale in allowedLocales)) {
    locale = allowedLocales.uk;
  }

  try {
    // eslint-disable-next-line one-var, no-var, no-return-assign, vars-on-top, no-async-promise-executor, prefer-template, guard-for-in, no-restricted-syntax, no-unused-expressions, no-console, @typescript-eslint/no-unused-expressions
    const bootstrap = (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))});
    bootstrap({
      key: window.GOOGLE_MAP_KEY,
      language: locale,
      loading: "async",
    });

    await Promise.all([
      window.google.maps.importLibrary("marker"),
    ]);

    await loadScript("https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js");
    
    googleMapClasses = window.google.maps;
    thisMap = new googleMapClasses.Map(mapHolder, {
      ...mapOptions,
      mapTypeId: googleMapClasses.MapTypeId?.ROADMAP || "roadmap",
    });
    bounds = new googleMapClasses.LatLngBounds();

    callback?.();
  } catch {
    throw new Error("Failed to initialize the map.");
  }
}

/**
 * Calculates the zoom level for a given bounds and map dimensions.
 * @param {google.maps.LatLngBounds} curBounds - The bounds to fit the map to.
 * @param {Object} mapDim - The dimensions of the map.
 * @param {number} mapDim.height - The height of the map in pixels.
 * @param {number} mapDim.width - The width of the map in pixels.
 * @return {number} The calculated zoom level.
 */
function getBoundsZoomLevel(curBounds, mapDim) {
  const WORLD_DIM = { height: 256, width: 256 };
  const ZOOM_MAX = 21;

  function latRad(lat) {
    const sin = Math.sin((lat * Math.PI) / 180);
    const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
  }

  function zoom(mapPx, worldPx, fraction) {
    return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
  }

  const ne = curBounds.getNorthEast();
  const sw = curBounds.getSouthWest();

  const latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

  const lngDiff = ne.lng() - sw.lng();
  const lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

  const latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
  const lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

  return Math.min(latZoom, lngZoom, ZOOM_MAX);
}

const getCityId = () =>
  $(".city-search .search-dropdown li.active").attr("data-id");

const map = () => {
  const locale = $("html").attr("lang");
  function initialize() {
    function inputCoords(coordinates) {
      if (!coordinates) return;
      
      if (!googleMapClasses) {
        initializeMap(() => {
          inputCoords(coordinates);
        });
        return;
      }

      const isMapOpen = document.querySelector(".js_map")

      for (let i = 0; i < coordinates.length; i++) {
        const coords = coordinates[i];
        const position = new googleMapClasses.LatLng(coords.lat, coords.lng);

        bounds.extend(position);

        const marker = new googleMapClasses.marker.AdvancedMarkerElement({
          position,
          map: thisMap,
          title: "123",
          content: createCustomMarkerContent(coords),
        });

        if (isMapOpen) {
          marker.addListener("click", () => {
            $(".js_store_card").fadeIn();
            getStoreInfo(coords.id);
          });
        }

        markers.push(marker);
      }
      // Hide store card on map click
      googleMapClasses.event.addListener(thisMap, "click", () => {
        $(".js_store_card").fadeOut();
      });

      markerCluster = new window.markerClusterer.MarkerClusterer(
        {
          map: thisMap, 
          markers,
          algorithmOptions: {
            // maxZoom: 20,
            extent: 256,
          },
          renderer: {
            render: ({ count, position }) => {
              const parser = new DOMParser()
              const svg = `<svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle opacity=".2" cx="25" cy="25" r="25" fill="#00502F"/>
                      <circle cx="25" cy="25" r="19" fill="#0D6843"/>
                      <text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="12" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
                      </svg>`
              const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement
              const clusterOptions = {
                map: thisMap,
                position,
                content: svgEl,
              }
              return new googleMapClasses.marker.AdvancedMarkerElement(clusterOptions)
            },
          },
        }
      );

      thisMap.fitBounds(bounds);
      thisMap.panToBounds(bounds);

      const boundsListener = googleMapClasses.event.addListener(
        thisMap,
        "bounds_changed",
        () => {
          const zoom =
            coordinates.length === 1
              ? 13
              : getBoundsZoomLevel(bounds, {
                  height: mapHeight,
                  width: mapWidth,
                });

              thisMap.setZoom(zoom);
          googleMapClasses.event.removeListener(boundsListener);
        }
      );
    }

    function createCustomMarkerContent() {
      // Create custom HTML content for the marker
      const div = document.createElement("div");
      div.className = "custom-marker";
      div.innerHTML = `
        <div class="marker-icon">
          <img src="${window.imageMarker}" alt="Marker Icon" />
        </div>
      `;
      return div;
    }

    const generatePagin = (currentPage, lastPage) => {
      let layout = "";
      const pagination = $(".pagination");

      if (lastPage !== 1) {
        let loop = 0;
        const currentURL = new URL(window.location.href);
        const dots = `<li class="dots"><span><svg class="icon-dots"><use xlink:href="#dots"></use></svg></span></li>`;

        const arrow = (className, pageNumber) => {
          currentURL.searchParams.set("page", pageNumber);
          pageNumber === 1 && currentURL.searchParams.delete("page");
          return `<li class=" pagination-button ${className}"><a href="${currentURL.toString()}"><svg class="icon-arrow"><use xlink:href="#arrow"></use></svg></a></li>`;
        };
        
        const paginationItem = (number, className = "") => {
          currentURL.searchParams.set("page", number);
          number === 1 && currentURL.searchParams.delete("page");
          return `<li class="${className}${
            number === currentPage ? " active" : ""
          }"><a href="${currentURL.toString()}">${number}</a></li>`;
        };

        // generate loop
        if (lastPage >= 5 && currentPage >= 7) {
          loop = 7;
        } else if (lastPage >= 5 && currentPage < 7) {
          loop = 6;
        }

        if (lastPage - 4 < loop && lastPage - 4 > 0) {
          loop = lastPage - 4;
        }
        // ==================
        // button prev
        if (currentPage > 1) {
          layout += arrow("prev", currentPage - 1);
        }

        // items from 1 to 2
        if (lastPage >= 2) {
          const className = lastPage === 2 ? "last" : "";

          layout += paginationItem(1, "first");
          
          // fake item for last page on mobile 
          if (className === "last" && currentPage === lastPage) {
            layout += paginationItem(2, "fake");
          }

          layout += paginationItem(2, className);
        }

        // generate list
        // dot
        if (loop === 7 && lastPage >= 12) {
          layout += dots;
        }

        for (let i = 1; i <= loop; i += 1) {
          let number = 2;

          if (loop === 6) {
            number = i + 2;
          } else if (loop === 7) {
            number = lastPage - 2 - (loop - i);
            if (lastPage - 6 >= currentPage) {
              if (i < 4) {
                number = currentPage - (4 - i);
              } else if (i === 4) {
                number = currentPage;
              } else {
                number = currentPage + (i - 4);
              }
            }
          } else {
            number += i;
          }

          layout += paginationItem(number);
        }

        // dot
        if ((loop === 6 && lastPage > 11) || (loop === 7 && lastPage > 12)) {
          if (currentPage < lastPage - 5) {
            layout += dots;
          }
        }

        // items from LastPage - 1  to LastPage
        if (lastPage >= 3) {
          if (lastPage !== 3) {
            layout += paginationItem(lastPage - 1);
          }
          
          // fake item for last page on mobile
          if (lastPage === currentPage) {
            layout += paginationItem(lastPage, "fake");
          }

          layout += paginationItem(lastPage, "last");
        }

        // button next
        if (currentPage < lastPage) {
          layout += arrow("next", currentPage + 1);
        }
      }

      const pag = `
        <div class="pagination">
          <ul class="pagination__list flex-c-c">
            ${layout}
          </ul>
        </div>
      `;
      if (pagination.length > 0) {
        pagination.html(pag);
      } else {
        $(".js_store_page").append(pag);
      }
    };

    const clearMap = () => {
      if (!markers || markers.length === 0) return;
      markers.forEach((marker) => {
        marker.setMap(null);
        markerCluster.removeMarker(marker);
        marker.open = false;
      });

      markers = [];
      markerCluster = null;
      bounds = new googleMapClasses.LatLngBounds();
      $(".js_store_card").fadeOut();
    };

    const createTemporaryLabel = (item) => item.temporary_close
        ? `<span class="store__status--error">${window.phrases.temporary_closed_label}</span>`
        : item.schedule && item.closed_at
        ? `${window.phrases.open_at} ${item.closed_at}`
        : item.schedule && item.open_at
        ? `${window.phrases.closed_at} ${item.open_at}`
        : "";

    const createScheduleRow = (day, info) => {
      const className = info.day_off
        ? "store__weekend"
        : info.open
        ? "store__today"
        : info.closed
        ? "store__today--closed"
        : "";
      return `<tr class="${className}">
                    <td>${window.phrases.days[day]}</td>
                    <td class="store__bold">
                        ${
                          info.day_off
                            ? window.phrases.day_off
                            : info.time_range
                        }
                    </td>
                </tr>`;
    };

    const createSchedule = (item) => item.schedule
        ? `<div class="store__schedule js_store_schedule">
                      <table class="store__table">
                          ${Object.keys(item.schedule)
                            .map((day) =>
                              createScheduleRow(
                                day,
                                item.schedule[day],
                                window.phrases
                              )
                            )
                            .join("")}
                      </table>
                  </div>`
        : "";

    const createJewelerLink = (item) => item.jeweler
        ? `<div class="store__footer_link jewellery__label">
                <div class="store__jewellery"></div>
                <div class="store__jewellery_text">${window.phrases.jeweler}</div>
            </div>`
        : "";

    const addCloseButton = (canBeClosed) => canBeClosed
        ? `<div class="store__close js_close_store_card"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6 6 12 12M18 6 6 18" stroke="#111" stroke-linecap="round" stroke-linejoin="round"/></svg></div>`
        : "";

    const createStoreCard = (card, canBeClosed) => `<div class="store__column js_store_info">
                    <a href="${card.url}" class="store-card store-card__primary">
                        <div class="store-card__image" style="background-image: url('${
                          card.image
                        }');"></div>
                        <div class="store-card__content">
                            <div class="store__data">
                                <div class="title">${card.title}</div>
                                <div class="store__status">${createTemporaryLabel(
                                  card
                                )}</div>
                            </div>
                            ${createSchedule(card)}
                        </div>
                        <div class="store__footer">
                            <div class="store__footer_link store__footer_hide js_show_schedule">
                                <div class="store__schedule_icon"></div>
                                <div class="store__show">${
                                  window.phrases.schedule
                                }</div>
                                <div class="store__schedule_arrow"></div>
                            </div>
                            <div class="store__footer_link">
                                <div class="store__pin"></div>
                                <div class="store__show">${
                                  window.phrases.on_map
                                }</div>
                            </div>
                            ${createJewelerLink(card, window.phrases)}
                        </div>
                    </a>
                    ${addCloseButton(canBeClosed)}
                </div>`;

    // const updateLocationsOnMap = () => {
    //   const activeCity = document.querySelector(".city-label .search-dropdown .active");
    //   const activeCityId = activeCity.getAttribute("data-id");
    //   const isExactCity =
    //     activeCity &&
    //     activeCityId !== "" &&
    //     activeCityId !== undefined &&
    //     activeCityId !== ALL_CITIES_ID;
    //   inputCoords(LatLng);
    // };

    const createStoreCardList = (response) => {
      const storesHolder = $(".stores-content__holder");
      const collection = [];
      const layout = response.data.map((item) => createStoreCard(item));

      storesHolder.html(layout);

      clearMap();
      LatLng = response.coordinates;
      inputCoords(LatLng);
    };

    const toggleFilters = (filters) => {
      if (filters) {
        Object.keys(filters).forEach((f) => {
          $(`.js_${f}_filter`)
            .closest(".checkbox")
            [filters[f] === 0 ? "addClass" : "removeClass"]("hide");
        });
      }
    };

    const updateLangPickerLinks = (cityUrlLocalizations) => {
      if (!cityUrlLocalizations) return;

      const changeLangUrlForEachLink = ($menuList) => {
        if (!$menuList.length || $menuList.length === 0) return;

        $menuList.forEach($menuListItem => {
          const $langLink = $menuListItem.querySelector('a');

          $langLink.href = cityUrlLocalizations[$langLink.dataset.lang];
        });
      }

      changeLangUrlForEachLink(document.querySelectorAll('.lang__dropdown > ul > li'));
      changeLangUrlForEachLink(document.querySelectorAll('.footer-lang > li'));
    }

    const updatePageSeo = (seoData) => {
      const $metaTitle = document.querySelector('meta[name="title"]');
      const $metaDescription = document.querySelector('meta[name="description"]');
      const $metaKeywords = document.querySelector('meta[name="keywords"]');
      const $pageTitle = document.querySelector('h1.wb-title');
      const $pageSeoBlock = document.querySelector('.block-seo');
      const $pageSeoContent = document.querySelector('.js_seo_content');

      // if seo data and proper dom elements are there => updating page
      // if not => setting attributes to empty values
      document.title = seoData && seoData.title ? seoData.title : "";
      $metaTitle.content = seoData && seoData.meta_title ? seoData.meta_title : "";
      $metaDescription.content = seoData && seoData.meta_description ? seoData.meta_description : "";
      $metaKeywords.content = seoData && seoData.meta_keywords ? seoData.meta_keywords : "";
      $pageTitle.innerText = seoData && seoData.h1 ? seoData.h1 : "";
      
      // hide seo block if no seo data
      if (seoData && seoData.ceo_text) {
        if ($pageSeoBlock) {
          $pageSeoContent.innerHTML = seoData.ceo_text;
          $pageSeoBlock.style.display = "block";
        }
      } else if ($pageSeoBlock) {
        $pageSeoBlock.style.display = "none";
        $pageSeoContent.innerHTML = "";
      }
    }

    const updateBreadcrumbs = (cityId, cityName, cityUrls) => {
      const $breadcrumbsContainer = document.querySelector('.breadcrumbs');
      const $breadcrumbsItems = document.querySelectorAll('.breadcrumbs > .breadcrumbs__item');
      if (!$breadcrumbsItems || !$breadcrumbsContainer || !cityName) return;
      
      const chosenCityUrl = cityUrls[cityUrls.current];
      const breadcrumbItemMarkup =
        `<li class="breadcrumbs__item"><a href="${chosenCityUrl}">${cityName}</a></li>`;

      if (cityId === ALL_CITIES_ID) {
        $breadcrumbsItems.forEach(($breadcrumbsItem, index) => {
          if (index > 1) {
            $breadcrumbsItem.remove();
          }
        });

        return;
      }

      if ($breadcrumbsItems.length > 2) {
        const $lastBreadcrumbItem = $breadcrumbsItems[$breadcrumbsItems.length - 1];
        const $lastBreadcrumbItemLink = $lastBreadcrumbItem.querySelector('a');
        
        $lastBreadcrumbItemLink.href = chosenCityUrl;
        $lastBreadcrumbItemLink.innerText = cityName;
      } else {
        $breadcrumbsContainer.insertAdjacentHTML('beforeend', breadcrumbItemMarkup);
      }
    }

    const updateCityList = (cityListObj) => {
      // Find list of cities in markup
      const cityListWrapper = document.querySelector(".city-search .search-dropdown ul")
      if (!cityListWrapper) return

      const currentCityId = getCityId()
      const allUkraineListItem = cityListWrapper.querySelector(
        `li[data-id='${ALL_CITIES_ID}']`,
      )
      let hasActiveItem
      // Create new list of cities from cityListObj

      const newCityListMarkup = Object.entries(cityListObj)
        .map(([cityId, cityName]) => {
          // Check if city from cityListObj is already in markup
          const isCurrentCity = currentCityId === cityId
          if (isCurrentCity) hasActiveItem = true
          return `<li ${
            isCurrentCity ? 'class="active"' : ""
          } data-id="${cityId}">${cityName}</li>`
        })
        .join("")

      if (!hasActiveItem && currentCityId !== ALL_CITIES_ID) {
        document
          .querySelector(".city-search.change-sity li[data-id=all]")
          .dispatchEvent(new Event("click", { bubbles: true }))
      } else {
        allUkraineListItem.style.display = ""
        // Create new list of cities from allUkraineListItem and newCityListMarkup
        cityListWrapper.innerHTML = allUkraineListItem.outerHTML + newCityListMarkup
      }
    }

    const initChangeLocationOnClick = (locale) => {
      const storeSelect = $(".city-search.change-sity");

      const query = (cityId, page, scrollTop = false, cityName) => {
        const isOpen = $(".js_open_filter").is(":checked");
        const hasJeweler = $(".js_jeweler_filter").is(":checked");
        $.ajax({
          url: `/${locale}/api/filial/get-filials`,
          type: "get",
          data: `${cityId !== undefined && cityId !== ALL_CITIES_ID ? `city_code=${cityId}&` : ""}page=${page}&open=${
            isOpen ? 1 : 0
          }&jeweler=${hasJeweler ? 1 : 0}`,
          dataType: "json",
          beforeSend: () => {
            preloader(true);
          },
          success: (success) => {
            createStoreCardList(success, cityId);
            generatePagin(
              success.pagination.current_page,
              success.pagination.last_page
            );
            toggleFilters(success.filter);
            updateLangPickerLinks(success.city_url);
            updatePageSeo(success.seo);
            updateCityList(success.cities);
            if (cityName) updateBreadcrumbs(cityId, cityName, success.city_url);

            if (scrollTop) {
              $("html,body").animate(
                { scrollTop: $(".main").offset().top },
                300
              );
            }
          },
          error: (error) => {
            console.log(error);
          },
        }).always(() => {
          preloader(false);
        });
      };

      const getPage = () => {
        $(document)
          .on(
            "click",
            ".pagination li:not(.dots):not(.active)",
            function countPagination() {
              let page = 1;
              const activePage = +$(".pagination li.active a").last().text();
              const lastValue = +$(".pagination .last a").text();
              const $this = $(this);

              if (!$this.hasClass("pagination-button")) {
                page = +$this.find("a").text();
              } else if ($this.hasClass("prev") && activePage - 1 >= 1) {
                page = activePage - 1;
              } else if (
                $this.hasClass("next") &&
                activePage + 1 <= lastValue
              ) {
                page = activePage + 1;
              }

              if (page !== activePage) {
                const id = $(".city-search .search-dropdown li.active").attr(
                  "data-id"
                );

                const searchParams = new URLSearchParams(
                  window.location.search
                );
                if (page !== 1) {
                  searchParams.set("page", `${page}`);
                } else {
                  searchParams.delete("page");
                }

                query(id, page, true);

                const params = searchParams.toString()
                  ? `?${searchParams.toString()}`
                  : "";

                window.history.pushState(
                  "",
                  "",
                  `${window.location.origin}${window.location.pathname}${params}`
                );
              }
            }
          )
          .on("click", ".pagination li", (event) => {
            event.preventDefault();
          });
      };

      storeSelect.on("click", "li:not(.active)", function getId() {
        const $this = $(this);
        const cityId = $this.attr("data-id");
        const cityName = $this.prop("innerText");
        const splitPathName = window.location.pathname.split("/");
        const sliceArr = splitPathName.slice(0, 3);
        const getPathName =
          sliceArr[1].length > 2 ? sliceArr.slice(0, 2) : sliceArr;

        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.toString().indexOf("page") > -1) {
          searchParams.delete("page");
        }
        const params = searchParams.toString();

        const nextPath = `${
            window.location.origin
          }${
            getPathName.join("/")
          }${
            cityId === ALL_CITIES_ID ? "" : `/${cityId}`
          }/${
            params ? `?${params}` : ""
          }`;

        window.history.pushState(
          "",
          "",
          nextPath
        );

        clearMap();
        query(cityId, 1, false, cityName);
        $(".header").removeClass("mobile-bg");
        // Erase search input
        $(".js-search-stores").val("");
        $(".js-search-stores").removeAttr("value", "");
      });

      getPage();

      $(".js_map_filter").on("change", function () {
        const name = $(this).attr("name");
        const searchParams = new URLSearchParams(window.location.search);
        const isChecked = $(this).is(":checked");
        if (isChecked) {
          searchParams.set(name, "1");
        } else {
          searchParams.delete(name);
        }
        if (searchParams.toString().indexOf("page") > -1) {
          searchParams.delete("page");
        }
        const params = searchParams.toString();
        if (params) {
          window.history.pushState(
            "",
            "",
            `${window.location.origin}${window.location.pathname}?${params}`
          );
        } else {
          window.history.pushState(
            "",
            "",
            `${window.location.origin}${window.location.pathname}`
          );
        }
        query(getCityId(), 1);
      });

      // For first open map. get-filials
      document.querySelectorAll(".js_store_tab").forEach((el) => {
        el.addEventListener("click", (e) => {
          if (!LatLng.length && !e.target.classList.contains("active")) {
            const cityId = document.querySelector(".city-search.change-sity li.active")
              .dataset.id;
            const pageNumber =
              new URLSearchParams(window.location.search).get("page") || 1;
            clearMap();
            query(cityId, pageNumber);
          }
        });
      });
      
      
    };

    LatLng.length && inputCoords(LatLng);



    if ($(".city-search.change-sity").length) {
      initChangeLocationOnClick(locale);
    }

    (() => {
      const trigger = $(".js_store_tab");
      trigger.on("click", function () {
        const $this = $(this);
        if (!$this.hasClass("active")) {
          const root = $this.closest(".js_store_page");
          $this.addClass("active").siblings().removeClass("active");
          root.toggleClass("active");

          const mapContainer = $("#map");
          mapWidth = mapContainer.width()
            ? mapContainer.width()
            : $(window).width();
          mapHeight = mapContainer.height() ? mapContainer.height() : mapWidth;
        }
      });
    })();

    const getStoreInfo = (id) => {
      if (cache[id]) {
        $(".js_store_card").html(cache[id]);
      } else {
        $.ajax({
          url: `/api/filials/${id}/`,
          type: "get",
          headers: {
            "Accept-Language": locale,
          },
          dataType: "json",
          beforeSend: () => {
            preloader(true);
          },
          success: (success) => {
            const layout = createStoreCard(success, true);
            cache[id] = layout;
            $(".js_store_card").html(layout);
          },
          error: (error) => {
            console.log(error);
          },
        }).always(() => {
          preloader(false);
        });
      }
    };

    $(document)
      .on("click", ".js_close_store_card", function () {
        $(this).closest(".js_store_card").fadeOut();
      })
      .on("click", ".js_show_schedule", function (e) {
        e.preventDefault();
        const that = $(this);
        that.toggleClass("active");
        const target = that
          .closest(".js_store_info")
          .find(".js_store_schedule");
        target.toggleClass("active");
        const coords = that.offset();
        const wrapperCoords = that.closest(".js_store_info").offset();
        target.css({
          top: coords.top - wrapperCoords.top,
          left: coords.left - wrapperCoords.left,
          width: that.outerWidth(),
        });
      })
      .on("click", ".js_store_schedule", (e) => {
        e.preventDefault();
      })
      .on("click", (e) => {
        const that = $(e.target);
        const shouldHideSchedule =
          that.closest(".js_store_schedule, .js_show_schedule").length < 1;
        if (shouldHideSchedule) {
          $(".js_store_schedule, .js_show_schedule").removeClass("active");
        }
      });
    $(window).on("resize", () => {
      $(".js_store_schedule, .js_show_schedule").removeClass("active");
    });
    window.addEventListener("popstate", () => {
      document.location.reload();
    });
  }

  initialize();
};
export default map;
